<div *ngIf="!dashboard">
    <app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'CLINICAL-MESSAGES'" [breadcrumb]="breadcrumb"
        [isStringLiteral]="stringLiteralBreadcrumb" [count]="count" icon="fa-inbox-in">
    </app-breadcrumb>
</div>
<div class="content-background">
    <div class="row">
        <div class="col-sm-12">
            <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                <app-advanced-mode id="clinicalMessageGridAutoExpandSwitch"
                    [storageKey]="'clinical-message-list-expand'" [titleKey]="'AUTO-EXPAND'"
                    (collapsibleToggle)="enableAutoExpand=$event" class="mr-4">
                </app-advanced-mode>
                <app-advanced-mode id="clinicalMessageGridAdvancedSwitch" [storageKey]="'clinical-message-list'"
                    (collapsibleToggle)="enableAdvanced=$event">
                </app-advanced-mode>
                <input #search kendoTextBox class="ml-4 button-search"
                    placeholder="{{ 'SEARCH-CLINICAL-MESSAGE' | translate }}"
                    title="{{ 'SEARCH-CLINICAL-MESSAGE' | translate }}" (keyup)="searchFieldChange(search.value)" />
                <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <kendo-grid #grid [data]="gridView" [navigable]="true"
            [pageable]="count > state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="state.take"
            [skip]="state.skip" [loading]="loading" [sort]="state.sort" [filter]="state.filter" [sortable]="true"
            [filterable]="enableAdvanced" [columnMenu]="enableAdvanced" [resizable]="true"
            [reorderable]="enableAdvanced" [selectedKeys]="selectedClinicalMessageKeys" [kendoGridSelectBy]=""
            (dataStateChange)="dataStateChange($event)" (cellClick)="onCellClick($event)"
            [selectable]="{ mode: 'single' }">
            <kendo-grid-messages noRecords="{{ 'NO-CLINICAL-MESSAGES' | translate }}">
            </kendo-grid-messages>
            <kendo-grid-column field="createdOn" title="{{ 'RECEIVED' | translate }}" [width]="60" filter="date"
                format="{0:d}">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span>{{intl.formatDate(intl.parseDate(dataItem.createdOn), "g")}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="fullName" title="{{ 'MEMBER' | translate:patientLabel }}" [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <a *ngIf="dataItem.memberId > 0" [routerLink]="['/patient', dataItem.memberId]"
                        [queryParams]="{breadcrumb: 'ALL'}" class="pointer">
                        {{ dataItem.fullName }}
                    </a>
                    <span *ngIf="!dataItem.memberId">{{ dataItem.fullName }}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="eventType" title="{{ 'EVENT-TYPE' | translate }}" [width]="70">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.eventType }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="facility" title="{{ 'FACILITY' | translate }}" [width]="60">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{ dataItem.facility }}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="size" title="{{'SIZE' | translate}}" [width]="60">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.size}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedOn" title="{{'PROCESSED' | translate}}" [width]="60" filter="date"
                format="{0:d}">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span *ngIf="lastModifiedOn !== null">{{intl.formatDate(intl.parseDate(dataItem.lastModifiedOn),
                        "g")}}</span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="caseCount" title="{{'CASES' | translate}}" [width]="50">
                <ng-template kendoGridCellTemplate let-dataItem>
                    {{dataItem.caseCount}}
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-command-column [width]="30" title="{{ 'ACTIONS' | translate }}" class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i *ngIf="dataItem.lastModifiedOn !== null" class="fas fa-repeat fa-lg"
                        title="{{ 'REPROCESS-MESSAGE' | translate }}" (click)="reprocessConfirmation(dataItem['id'])">
                    </i>
                </ng-template>
            </kendo-grid-command-column>
            <ng-template kendoGridDetailTemplate let-dataItem [kendoGridDetailTemplateShowIf]="showDetails">
                <app-clinical-message-detail [clinicalMessageId]="dataItem.id">
                </app-clinical-message-detail>
            </ng-template>
        </kendo-grid>
    </div>
</div>

<!-- delete code confirmation dialog -->
<kendo-dialog *ngIf="reprocessDialogOpened" title="{{'PLEASE-CONFIRM' | translate}}" [width]="400"
    (close)="reprocessDialogOpened = false">
    <p>{{'REPROCESS-MESSAGE-CONFIRMATION' | translate}}</p>
    <kendo-dialog-actions>
        <button kendoButton (click)="reprocessDialogOpened = false">{{'NO' | translate}}</button>
        <button appPreventClick kendoButton (click)="reprocessMessage(selectedMessageId)">{{'YES' | translate}}</button>
    </kendo-dialog-actions>
</kendo-dialog>